import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

export function PasswordInput({ value, onChange, testId, className = "", placeholder = "Almeno 6 caratteri", minLength = 6, autoComplete = "current-password" }) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <input
        type={show ? "text" : "password"}
        required
        minLength={minLength}
        value={value}
        onChange={onChange}
        data-testid={testId}
        placeholder={placeholder}
        autoComplete={autoComplete}
        className={`${className} pr-12`}
      />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        data-testid={`${testId}-toggle`}
        aria-label={show ? "Nascondi password" : "Mostra password"}
        className="absolute inset-y-0 right-0 flex w-12 items-center justify-center text-[#B4B4BC] hover:text-[#D4AF37]"
      >
        {show ? <EyeOff size={19} /> : <Eye size={19} />}
      </button>
    </div>
  );
}
